export default (data) => ({
    licenseId: data.licenseId,
    open: false,
    rollover: false,
    toggle() {
        this.open = !this.open
        if (!this.open) {
            this.$dispatch('option-closed', { license: this.licenseId })
        }
    },
    text: 'Buying options',
    get summary() {
        let summary = '';
        for (const item of this.$store.cart.data) {
            if (item.item === this.licenseId) {
                for(const lic of item.licenseItems) {
                    summary += '<span>' + lic + '</span>';
                }
                return summary;
                // return '> ' + item.licenseItems.join(' | ')
            }
        }
        return ''
    },
    liveSummary: undefined, // Summary for current selection, propagated up from license component
    type: null,
    info: {},
    get inCart() {
        if (!this.$store.cart) {
            return false;
        }
        for (const val of this.$store.cart.data) {
            if (val.item === this.licenseId) {
                return true
            }
        }
        return false
    }
})